import { WebViewComponent } from '@/components/WebView'
import { useStore } from '@/models'

const PROD_STRIPE_URL = 'https://billing.stripe.com/p/login/8wM5mdb4LdKZ2Xu9AA'
const TEST_STRIPE_URL = 'https://billing.stripe.com/p/login/test_dR6aIg5rn4wi544fYY'

export default function () {
  const {
    environment: { stage }
  } = useStore()
  const url = stage === 'prod' ? PROD_STRIPE_URL : TEST_STRIPE_URL
  return <WebViewComponent url={url} />
}
